import {
  CircleAlertIcon,
  InfoIcon,
  type LucideIcon,
  TriangleAlertIcon,
} from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export type NoticeTone = "info" | "warning" | "danger";

const TONES: Record<NoticeTone, { className: string; icon: LucideIcon }> = {
  info: {
    className: "border-info-border bg-info-bg text-info",
    icon: InfoIcon,
  },
  warning: {
    className: "border-warning-border bg-warning-bg text-warning",
    icon: TriangleAlertIcon,
  },
  danger: {
    className: "border-destructive-border bg-destructive-bg text-destructive",
    icon: CircleAlertIcon,
  },
};

type Props = {
  tone?: NoticeTone;
  toneLabel: string;
  className?: string;
  children: ReactNode;
};

export function Notice({
  tone = "info",
  toneLabel,
  className,
  children,
}: Props) {
  const { className: toneClass, icon: Icon } = TONES[tone];

  return (
    <div
      className={cn(
        "flex items-start gap-2 rounded-md border px-3 py-2 text-sm leading-snug",
        toneClass,
        className
      )}
    >
      <Icon className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
      <p className="min-w-0">
        <span className="sr-only">{`${toneLabel}: `}</span>
        {children}
      </p>
    </div>
  );
}
